import React, { lazy } from 'react';
import { History, Code, Briefcase } from 'lucide-react';
export function AboutSection() {
  return <section className="py-16 bg-slate-50 border-t border-slate-200" data-id="element-17">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="grid md:grid-cols-3 gap-12" data-id="element-19">
          <div className="md:col-span-1" data-id="element-20">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 sticky top-8" data-id="element-21">
              <h3 className="font-bold text-lg mb-4" data-id="element-22">Über den Gründer</h3>
              <div className="w-20 h-20 bg-slate-200 rounded-full mb-4 overflow-hidden" data-id="element-23">
                <img src="https://cdn.magicpatterns.com/uploads/hvDwp8eai2TZvgE2zzHb3Q/DSC_9203_-_square.png" alt="Justus Kraft, Gründer von CRM Kraft" className="w-full h-full object-cover" loading="lazy" width="80" height="80" data-id="element-24" />
              </div>
              <h4 className="font-bold text-xl text-slate-900" data-id="element-25">Justus Kraft</h4>
              <p className="text-slate-500 text-sm mb-4" data-id="element-26">
                Gründer & Geschäftsführer
              </p>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-27">
                Startete mit 16 Jahren sein erstes Gewerbe. Heute, mit 23, hilft
                er Unternehmen, ihren Vertrieb durch intelligente CRM-Systeme zu
                skalieren.
              </p>
            </div>
          </div>

          <div className="md:col-span-2" data-id="element-28">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-29">
              Die Geschichte hinter CRM Kraft
            </h2>
            <div className="prose prose-slate max-w-none text-slate-600" data-id="element-30">
              <p className="mb-6" data-id="element-31">
                CRM Kraft entstand aus einer einzigartigen Kombination: Tiefe
                IT-Kenntnisse treffen auf echte Vertriebspraxis. Justus Kraft
                begann seine Reise nicht als theoretischer Berater, sondern als
                Entwickler, der die technischen Möglichkeiten verstand, und als
                Vertriebler, der die täglichen Schmerzen kannte.
              </p>
            </div>

            <div className="space-y-8 mt-8" data-id="element-32">
              <div className="flex gap-4" data-id="element-33">
                <div className="flex-shrink-0 mt-1" data-id="element-34">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-35">
                    <Code className="w-5 h-5" data-id="element-36" />
                  </div>
                </div>
                <div data-id="element-37">
                  <h3 className="font-bold text-slate-900" data-id="element-38">IT & Entwicklung</h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-39">
                    Fundierte Kenntnisse in PHP, JavaScript, Python und CSS
                    ermöglichen es CRM Kraft, Systeme nicht nur zu nutzen,
                    sondern tiefgreifend anzupassen und zu automatisieren.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-40">
                <div className="flex-shrink-0 mt-1" data-id="element-41">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-42">
                    <Briefcase className="w-5 h-5" data-id="element-43" />
                  </div>
                </div>
                <div data-id="element-44">
                  <h3 className="font-bold text-slate-900" data-id="element-45">
                    Vertrieb & Praxis
                  </h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-46">
                    3 Jahre aktive Vertriebserfahrung, Aufbau eigener Teams und
                    Arbeit als Setter und Vertriebsleiter. Wir wissen, was im
                    "Feld" wirklich funktioniert.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-47">
                <div className="flex-shrink-0 mt-1" data-id="element-48">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-49">
                    <History className="w-5 h-5" data-id="element-50" />
                  </div>
                </div>
                <div data-id="element-51">
                  <h3 className="font-bold text-slate-900" data-id="element-52">Mission</h3>
                  <p className="text-slate-600 text-sm mt-1 italic" data-id="element-53">
                    "Wir automatisieren alles außer den Spaß."
                  </p>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-54">
                    Damit sich Vertriebsteams auf das konzentrieren können, was
                    sie am besten können: Verkaufen.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}